import React, { useState, useEffect, useRef, useMemo } from 'react'
import { connect } from 'react-redux';
import * as types from "../../../constants";
import { Grid, Typography, Snackbar, Box, FormControl, InputLabel, Select, MenuItem, TextField, Button } from '@mui/material';
import { fetchSubmissionsPatientInvestigationAction, fetchSlimSubmissionsPatientAction, resetPatientsSubmissionsError } from '../../../redux/actions/submissionsPatientActions';
import Loader from '../../../components/Loader';
import { BoxBckgr, CheckCircleOutlineSvg, ButtonGrey, ButtonCancel, ButtonContinue, TypographyStyled } from '../../../components/general/mini_components';
import Modal from '../../../components/general/modal';
import { useParams, useHistory } from 'react-router-dom';
import { yearsFromDate, postErrorSlack, getUnitsResearcher, getPatientID, birthdateToDate } from '../../../utils/index.jsx';
import FillDataCollection from '../FillDataCollection';
import { Translate, withLocalize } from 'react-localize-redux';
import { Alert } from "@mui/lab";
import { useDispatch } from "react-redux";
import { HOSPITAL_PATIENT, HOSPITAL_PATIENT_DATACOLLECTION, HOSPITAL_PATIENT_EDIT_PERSONAL_DATA,
        HOSPITAL_PATIENT_MAKE_TESTS,
        HOSPITAL_PATIENT_SECTION, HOSPITAL_PATIENT_SINGLE_SUBMISSION, HOSPITAL_PATIENT_SUBMISSION, HOSPITAL_PATIENT_TESTS } from '../../../routes/urls';
import ShowPatientRecords from '../../../components/investigation/show/single/show_patient_records';
import { useDepartments, usePatients, useSnackBarState, useUpdateEffect } from '../../../hooks';
import { fetchProfileInfoAction } from '../../../redux/actions/profileActions';
import { MEDICAL_SURVEYS, TYPE_SOCIAL_SURVEY,  TYPE_IMAGE_SURVEY, TYPE_LAB_SURVEY, TYPE_MEDICAL_SURVEY } from '../../../constants';
import { PatientToolBar } from './toolbar';
import { getPatientStaysAction, updatePatientStatusAction } from '../../../redux/actions/hospitalActions';
import { incrementalSyncPatientsAction } from '../../../redux/actions/patientsActions';
import { FUNCTIONALITY, PatientStatus } from '../../../constants/types';
import TabsSurveys from './TabsSurveys';
import RequestTable from '../Request/RequestTable';
import RequestForm from '../Request/RequestForm';
import { ServiceType } from '../Request/types';
import { PERMISSION } from '../../../components/investigation/share/user_roles';
import SubmissionsTable from './SubmissionsTable';
import { useDeletePatient } from '../../../hooks';
import TreatmentInpatientSelection from '../../../components/general/SmartFields/TreatmentInpatientSelection';
import StatusChangeModal from './StatusChangeModal';
import { ScheduleAppointmentModal } from './ScheduleAppointmentModal';
import { resolveDataCollectionSelected, shouldRenderLoaderForMissingSurvey } from './patientSurveySelection';


function urlToSection(urlType, dataCollectionSelected, permissions){
    try{
        if(typeof urlType === "undefined"){
            if(dataCollectionSelected === null && permissions.includes(PERMISSION.MEDICAL_READ)){
                return types.PATIENT_TOOLBAR_SECTION_MEDICAL;
            }
            else if(dataCollectionSelected === null && permissions.includes(PERMISSION.NURSE_FW)){
                return types.PATIENT_TOOLBAR_SECTION_NURSE;
            }
            switch(dataCollectionSelected.type){
                case types.TYPE_FILL_IMG_SURVEY:
                    return types.PATIENT_TOOLBAR_SECTION_IMAGE;
                case types.TYPE_FILL_LAB_SURVEY:
                    return types.PATIENT_TOOLBAR_SECTION_LAB;
            }
            switch(dataCollectionSelected.category){
                case types.CATEGORY_DEPARTMENT_MEDICAL:
                    return types.PATIENT_TOOLBAR_SECTION_MEDICAL;
                case types.CATEGORY_DEPARTMENT_SOCIAL:
                    return types.PATIENT_TOOLBAR_SECTION_SOCIAL;
                case types.CATEGORY_DEPARTMENT_NURSE:
                    return types.PATIENT_TOOLBAR_SECTION_NURSE;
                case types.CATEGORY_DEPARTMENT_PRESCRIPTIONS:
                    return types.PATIENT_TOOLBAR_SECTION_PRESCRIPTIONS;
                case types.CATEGORY_DEPARTMENT_PRESCRIPTIONS_FW:
                    return types.PATIENT_TOOLBAR_SECTION_PRESCRIPTIONS_INPATIENT;
            }
            
        }
        switch(urlType){
            case "images":
                return types.PATIENT_TOOLBAR_SECTION_IMAGE;
            case "lab":
                return types.PATIENT_TOOLBAR_SECTION_LAB;
            case "social":
                return types.PATIENT_TOOLBAR_SECTION_SOCIAL;
            case "shoe":
                return types.PATIENT_TOOLBAR_SECTION_SHOE;
            case "nurse":
                return types.PATIENT_TOOLBAR_SECTION_NURSE;
            case "prescriptions":
                return types.PATIENT_TOOLBAR_SECTION_PRESCRIPTIONS;
            default:
                return types.PATIENT_TOOLBAR_SECTION_MEDICAL;
        }
    }
    catch(error){
        console.log("Error en urlToSection", error);
        return types.PATIENT_TOOLBAR_SECTION_MEDICAL; 
    }
    
}


const TYPE_URL = {1 : "images", 2 : "lab", 6 : "social", 7:"shoe", 12:"nurse", 13:"prescriptions", 15:"care_giver", 17:"prescriptions-inpatient"};
const URL_TYPE = Object.keys(TYPE_URL).reduce((newDict, key) =>{
    newDict[TYPE_URL[key]] = parseInt(key);
    return newDict
}, {})

function Patient(props) {
    let { uuidPatient } = useParams();
    const currentInvestigation = props.investigations.currentInvestigation;
    if(props.loading || !currentInvestigation || !props.patients.data || !props.patients.data[currentInvestigation.uuid]){
        return <Loader />
    }
    else{
        return <PatientView key={uuidPatient} {...props} />
    }
}

function PatientView(props) {
    //const { patients } = usePatients(props.investigations.currentInvestigation.uuid);
    const patients = props.patients.data[props.investigations.currentInvestigation.uuid];
    const [loading, setLoading] = useState(props.initialState ? props.initialState.loading : false)
    const [error, setError] = useState(props.initialState ? props.initialState.error : false)
    const [saved, setSaved] = useState(props.initialState ? props.initialState.saved : false);
    const [showMenuHospitalize, setShowMenuHospitalize] = useState(false);
    const [dischargeConfirm, setDischargeConfirm] = useState(false);
    const [showStatusChangeModal, setShowStatusChangeModal] = useState(false);
    const [showScheduleAppointmentModal, setShowScheduleAppointmentModal] = useState(false);
    const [showSurgicalListModal, setShowSurgicalListModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showSnackbar, setShowSnackbar] = useSnackBarState();
    const [surveyRecords, setSurveyRecords] = useState(null);
    const [showOptions, setShowOptions] = useState(false);
    const [indexMedicalNote, setIndexMedicalNote] = useState(null);
    const [indexDataCollection, setIndexDataCollection] = useState(-1);
    const [savedDataCollection, setSavedDataCollection] = useState(false);
    const [showRequestType, setShowRequestType] = useState(-1);
    
    
    const {departments, researchers, loadingDepartments } = useDepartments();
    
    const dispatch = useDispatch();
    let { uuidPatient } = useParams();
    let { uuidSection } = useParams();
    let { uuidDataCollection } = useParams();
    const {loadingDeletePatient, deletedPatient, deletePatientService} = useDeletePatient(props.investigations.currentInvestigation.uuid, uuidPatient);
    let { action } = useParams();
    let { single } = useParams();
    
    const parameters = useParams();

    let idSubmission;
    if (parameters["idSubmission"]) {
        idSubmission = parseInt(parameters["idSubmission"]);
    } 
    else {
        idSubmission = parameters["idSubmission"];
    }

    let submission;
    if (idSubmission && surveyRecords) {
        submission = surveyRecords.find(rec => rec.id === idSubmission);
    } 
    else {
        submission = null;
    }

    const history = useHistory();
    const billingInfo = props.investigations.currentInvestigation ? props.investigations.currentInvestigation.billingInfo : null;
    
    const currentSurveys = props.investigations.currentInvestigation ? props.investigations.currentInvestigation.surveys.filter((survey) => {
        const roleNurse = props.investigations.currentInvestigation ? props.investigations.currentInvestigation.permissions.includes(PERMISSION.NURSE_FW) : false;
        const hasMedicalReadPermission = props.investigations.currentInvestigation ? props.investigations.currentInvestigation.permissions.includes(PERMISSION.MEDICAL_READ) : false;
        if(parameters.typeTest === "social" && survey.category === types.CATEGORY_DEPARTMENT_SOCIAL){
            return true;
        }
        if(((!parameters.typeTest && !hasMedicalReadPermission) || parameters.typeTest === "nurse") && (survey.category === types.CATEGORY_DEPARTMENT_NURSE || survey.type === types.TYPE_CARE_GIVER || ( survey.category === types.CATEGORY_DEPARTMENT_NURSE_FW && survey.type === types.TYPE_NURSE && roleNurse ))){
            return true;
        }
        if(parameters.typeTest === "prescriptions" && (survey.category === types.CATEGORY_DEPARTMENT_PRESCRIPTIONS )){
            return true;
        }
        if(parameters.typeTest === "prescriptions-inpatient" && (survey.category === types.CATEGORY_DEPARTMENT_PRESCRIPTIONS_FW && roleNurse)){
            return true;
        }
        if(((!parameters.typeTest && hasMedicalReadPermission) || parameters.typeTest === "medical") && MEDICAL_SURVEYS.includes(survey.type) && (!survey.category || survey.category === types.CATEGORY_DEPARTMENT_MEDICAL)){
            return true;
        }
        if(parameters.typeTest === "images" && [types.TYPE_FILL_IMG_SURVEY, types.TYPE_IMAGE_SURVEY].includes(survey.type)){
            return true;
        }
        if(parameters.typeTest === "lab" && [types.TYPE_FILL_LAB_SURVEY, types.TYPE_LAB_SURVEY].includes(survey.type)){
            return true;
        }
    }) : [];




    //const dataCollectionSelected = props.investigations.data ? (submission ? props.investigations.currentInvestigation.surveys.find(sur => sur.uuid === submission.uuidSurvey) : uuidDataCollection ? props.investigations.currentInvestigation.surveys.find(sur => sur.uuid === uuidDataCollection) : indexDataCollection !== -1 ? currentSurveys[indexDataCollection] : null) : null;

    let dataCollectionSelected;

  
    if (!props.investigations.data) {
        dataCollectionSelected = null;
    } 
    
    else {
        if (submission) {
            dataCollectionSelected = props.investigations.currentInvestigation.surveys.find(
                sur => sur.uuid === submission.uuidSurvey
            );
        } 
        else if (uuidDataCollection) {
            // SHER-406: returns undefined when the URL's survey UUID is not in
            // the loaded surveys (deleted, stale link, or not yet loaded).
            dataCollectionSelected = resolveDataCollectionSelected(
                props.investigations.currentInvestigation.surveys,
                uuidDataCollection
            );
        }
        else if (indexDataCollection !== -1) {
            dataCollectionSelected = currentSurveys[indexDataCollection];
        } 
        else {
            dataCollectionSelected = null;
        }
    }

    const isPrescriptionsInpatientSection = !dataCollectionSelected ? currentSurveys.length > 0 && 
    (currentSurveys[0].category === types.CATEGORY_DEPARTMENT_PRESCRIPTIONS_FW) : dataCollectionSelected.category === types.CATEGORY_DEPARTMENT_PRESCRIPTIONS_FW;

    console.log(dataCollectionSelected)

    const typesCurrentSurvey = dataCollectionSelected ? (MEDICAL_SURVEYS.includes(dataCollectionSelected.type) ? MEDICAL_SURVEYS : [dataCollectionSelected.type]) : (parameters.hasOwnProperty("typeTest") ? (URL_TYPE[parameters["typeTest"]] ? [URL_TYPE[parameters["typeTest"]]] : MEDICAL_SURVEYS) : MEDICAL_SURVEYS);
    
    //const surveyRecords = props.patientsSubmissions.data && props.patientsSubmissions.data[uuidPatient] ? props.patientsSubmissions.data[uuidPatient] : [];
    const patient = patients.find(pat => pat.uuid === uuidPatient);
    const staysPatient = props.hospital.data.stays && props.hospital.data.stays[uuidPatient] ? props.hospital.data.stays[uuidPatient] : [];
    const typeSurveySelected = typesCurrentSurvey.length === 1 ? typesCurrentSurvey[0] : dataCollectionSelected ? dataCollectionSelected.type : TYPE_MEDICAL_SURVEY;
    const categorySurveySelected = dataCollectionSelected ? dataCollectionSelected.category : null;
    const sectionSelected = dataCollectionSelected && typeof uuidSection !== "undefined" ? dataCollectionSelected.sections.find(sec => sec.uuid === uuidSection) : null;
    const typesSurvey = props.investigations.data ? props.investigations.currentInvestigation.surveys.map((survey) => {
            return survey.type;
    }) : [];
    const categorySurveys = props.investigations.data ? [...new Set(props.investigations.currentInvestigation.surveys.map(survey => survey.category))]: [];
    let filteredRecords = useMemo(() => {
        if(idSubmission && surveyRecords){
            const currentSub = surveyRecords.find((rec) => rec.id === idSubmission);
            if(currentSub && currentSurveys.length > 0){
                return surveyRecords.filter(rec => {
                    return currentSurveys.some((sur) => sur.uuid === rec.uuidSurvey);
                });
                // return surveyRecords.filter(rec => {
                //     return props.investigations.currentInvestigation.surveys.find((sur) => sur.uuid === currentSub.uuidSurvey) !== undefined;
                // })
            }
        }
        if(dataCollectionSelected){
            return surveyRecords ? surveyRecords.filter(rec => {
                return rec.uuidSurvey === dataCollectionSelected.uuid;
            }) : [];
        }
        return surveyRecords ? surveyRecords.filter(rec => {
            return currentSurveys.find((sur) => sur.uuid === rec.uuidSurvey) !== undefined;
        }) : [];
    }, [currentSurveys, surveyRecords, idSubmission]);

    if(typeSurveySelected === TYPE_MEDICAL_SURVEY){
        staysPatient.forEach((stay) => {
            if(stay.prevTransferStay){
                const stayPrevStay = staysPatient.find((stayLink) => stay.prevTransferStay && stay.prevTransferStay.id === stayLink.id);
                let label = "hospital.patient.transfered-to-ward";
                if(stayPrevStay && stayPrevStay.bed.ward.uuid === stay.bed.ward.uuid){
                    label = "hospital.patient.changed-bed-same-ward";
                }
                filteredRecords.push({
                    researcher : stay.checkInResearcher.researcher.name +" "+stay.checkInResearcher.researcher.surnames,
                    surveyName : props.translate(label).toString().replace("%X", stay.bed.ward.name),
                    createdAt : stay.dateIn,
                    type:"stay"
                })
            }
            else{
                filteredRecords.push({
                    researcher : stay.checkInResearcher.researcher.name +" "+stay.checkInResearcher.researcher.surnames,
                    surveyName : props.translate("hospital.patient.hospitalized-in-ward").toString().replace("%X", stay.bed.ward.name),
                    createdAt : stay.dateIn,
                    type:"stay"
                })
            }
            const stayLinked = staysPatient.find((stayLink) => stayLink.prevTransferStay && stayLink.prevTransferStay.id === stay.id);
            if(stay.dateOut && !stayLinked){
                const dischargeLabel = stay.disposition === "DECEASED"
                    ? "hospital.patient.discharged-deceased-from-ward"
                    : "hospital.patient.discharged-from-ward";
                const checkoutRes = stay.checkoutResearcher?.researcher;
                filteredRecords.push({
                    researcher : checkoutRes ? checkoutRes.name + " " + checkoutRes.surnames : "—",
                    surveyName : props.translate(dischargeLabel).toString().replace("%X", stay.bed.ward.name),
                    createdAt : stay.dateOut,
                    type:"stay"
                })  
            }
        })
    }
    
    filteredRecords.sort((a, b) => {
        return new Date(a.createdAt) < new Date(b.createdAt) ? 1 : -1
    })
    
    const translations = typesCurrentSurvey.includes(TYPE_MEDICAL_SURVEY) ? "patient" : typesCurrentSurvey.includes(TYPE_IMAGE_SURVEY) ? "medical-imaging" : typesCurrentSurvey.includes(TYPE_LAB_SURVEY) ?  "laboratory" : "other"; 

    function goToSubmissionUrl(uuidPatient, idSubmission){
        const nextUrl = HOSPITAL_PATIENT_SINGLE_SUBMISSION.replace(":uuidPatient", uuidPatient)
                .replace(":action", "show")
                .replace(":idSubmission", idSubmission)
                .replace(":typeTest", parameters.typeTest);
        history.push(nextUrl);
    }

    function addRecord(){
        if(currentSurveys.length > 1 ){
            setShowOptions(true);
            setShowModal(true);
        }
        else{
            let nextUrl;
            
            
            if((["images", "lab"].includes(parameters.typeTest) && props.investigations.currentInvestigation.functionalities.includes(FUNCTIONALITY.REQUESTS)) ||
                (parameters.typeTest === 'shoe' && props.investigations.currentInvestigation.functionalities.includes(FUNCTIONALITY.SHOE_SHOP))){
                nextUrl = HOSPITAL_PATIENT_MAKE_TESTS.replace(":uuidPatient", uuidPatient).replace(":typeTest", parameters.typeTest);
            }
            else{
                const filterType = URL_TYPE[parameters.typeTest];    

                let dataCollection;

                if (dataCollectionSelected) {
                    dataCollection = dataCollectionSelected;
                }
                
                else {
                    dataCollection = currentSurveys.find(sur => sur.type === filterType);
                }

                console.log(dataCollection);

                nextUrl = HOSPITAL_PATIENT_DATACOLLECTION.replace(":uuidDataCollection", dataCollection.uuid)
                    .replace(":uuidPatient", uuidPatient).replace(":action", "fill")
                    .replace(":idSubmission", "");
            }
            history.push(nextUrl);
        }
    }
    async function discharge(){
        const dischargeSurvey = props.investigations.currentInvestigation.surveys.find((sur) => sur.type === types.TYPE_DISCHARGE_SURVEY);
        if(dischargeSurvey){
            const nextUrl = HOSPITAL_PATIENT_DATACOLLECTION.replace(":uuidDataCollection", dischargeSurvey.uuid)
                .replace(":uuidPatient", uuidPatient).replace(":action", "fill")
                .replace(":idSubmission", "");
            console.log("Next url", nextUrl);

            resetModal();

            history.push(nextUrl);
        }
        else{
            setShowSnackbar({show:true, severity: "warning", message : "hospital.patient.error.missing-discharge-survey"});
        }
        //
    }

    useEffect(() => {
        if(deletedPatient){
            setTimeout(() => {
                history.goBack();
            }, 3000);
        }
    }, [deletedPatient])

    function deletePatient(){
        console.log("deletePatient");
        deletePatientService();
    }
    function goToTest(value){
        if(value === TYPE_MEDICAL_SURVEY){
            backToRoot();
            return;
        }
        const nextUrl = HOSPITAL_PATIENT_TESTS.replace(":uuidPatient", uuidPatient).replace(":typeTest", TYPE_URL[value])
        history.push(nextUrl);
    }

    function fillDataCollection(uuidDataCollection){
        setSavedDataCollection(false);
        const dataCollectionSelected = currentSurveys.find((survey) => survey.uuid === uuidDataCollection);

        console.log(dataCollectionSelected);

        let isDisabled = false;
        // if(!dataCollectionSelected.repeats){
        //     const patientSubmissions = props.patientsSubmissions.data[uuidPatient].hasOwnProperty(dataCollectionSelected.uuid) ? props.patientsSubmissions.data[uuidPatient][dataCollectionSelected.uuid].submissions : [];
        //     isDisabled =  numberRecordsSection(sectionSelected, patientSubmissions) > 0;
        // }
        
        if(isDisabled){
            setShowSnackbar({show:true, severity: "warning", message : "investigation.fill.survey.section-filled"});
        }
        else{
            const nextUrl = HOSPITAL_PATIENT_DATACOLLECTION.replace(":uuidDataCollection", dataCollectionSelected.uuid)
                .replace(":uuidPatient", uuidPatient).replace(":action", "fill")
                .replace(":idSubmission", "");
            console.log("Next url", nextUrl);

            resetModal();

            history.push(nextUrl);
        }
    }
    function callBackEditSubmission(idSubmission, uuidSection){
        const submission = surveyRecords.find(sub => sub.id === idSubmission);
        const nextUrl = HOSPITAL_PATIENT_SECTION.replace(":uuidDataCollection", submission.uuidSurvey)
                .replace(":uuidPatient", uuidPatient).replace(":action", "update").replace(":uuidSection", uuidSection)
                .replace(":idSubmission", idSubmission);
        resetModal();
        //setIndexDataCollection(-1);
        //setIndexSection(-1);
        history.push(nextUrl);
    }

    function backToRoot(){
        const nextUrl = HOSPITAL_PATIENT.replace(":uuidPatient", uuidPatient);
        console.log("Next url", nextUrl);
        history.push(nextUrl);
    }
    function selectSubmission(index){
        console.log("Row seleccionado ", filteredRecords[index]);
        if(filteredRecords[index].offline){
            setShowSnackbar({show:true, severity: "warning", message : "investigation.fill.survey.record-offline"});
        }
        else if(filteredRecords[index].id){
            goToSurveyUrl(filteredRecords[index].id);
        }
        
    }
    function cancelRequest(){
        let nextUrl = HOSPITAL_PATIENT_TESTS.replace(":uuidPatient", uuidPatient).replace(":typeTest", parameters.typeTest);
        history.push(nextUrl);
    }

    function goToSurveyUrl(uuidSurvey){
        const nextUrl = HOSPITAL_PATIENT_SUBMISSION.replace(":uuidPatient", uuidPatient)
                            .replace(":action", "show")
                            .replace(":idSubmission", uuidSurvey)
                            .replace(":typeTest", parameters.typeTest ? parameters.typeTest : "medical");
        console.log("Next url", nextUrl);
        history.push(nextUrl);
    }
    function resetModal(){
        setShowOptions(false);
        setShowModal(false);
        setDischargeConfirm(false);
    }

    async function handleStatusChange(newStatus, deathData){
        try {
            await dispatch(updatePatientStatusAction(props.investigations.currentInvestigation.uuid, uuidPatient, newStatus, deathData));
            setShowSnackbar({show:true, severity:"success", message:"hospital.patient.updated-record"});
        } catch (err) {
            setShowSnackbar({show:true, severity:"error", message:"general.error"});
        }
    }

    async function saveRecord(data){
        // Save record solo gestiona el callback de social y medical, el resto son componentes y se gestionan de otra forma.
        // For inpatient prescriptions, stay on the current page (user may add more treatments)
        if(isPrescriptionsInpatientSection){
            return;
        }
        let nextUrl = HOSPITAL_PATIENT.replace(":uuidPatient", uuidPatient);
        if(dataCollectionSelected && Object.keys(TYPE_URL).includes(dataCollectionSelected.type.toString())){
            const url = TYPE_URL[dataCollectionSelected.type] === "care_giver" ? "nurse" : TYPE_URL[dataCollectionSelected.type];

            nextUrl = HOSPITAL_PATIENT_TESTS.replace(":uuidPatient", uuidPatient).replace(":typeTest", url )

        }
        setShowOptions(true);
        setIndexMedicalNote(null);
        setSavedDataCollection(true);

        setTimeout(function(){
            history.push(nextUrl);

        }, 1000);

    }
    function renderSurveys(){
        if(!dataCollectionSelected){
            return [
                <TabsSurveys surveys={currentSurveys} units={props.profile.info.units} 
                    departments={departments} surveySelectedCallback={(uuid) => fillDataCollection(uuid)} />
            ]
        }
    }
    function renderCore(){

        console.log(dataCollectionSelected)

        // SHER-406: a survey UUID in the URL may not match any loaded survey
        // (deleted server-side, stale link, or not yet loaded). `.find` returns
        // undefined in that case, and the `!== null` guard below would let it
        // through and crash on `dataCollectionSelected.uuid`. Show the Loader
        // instead of dereferencing an undefined survey.
        if(shouldRenderLoaderForMissingSurvey(uuidDataCollection, dataCollectionSelected)){
            return <Loader />
        }

        // Build merged list of all treatments for prescriptions section
        let listElements = null;
        if(isPrescriptionsInpatientSection && filteredRecords.length > 0){
            listElements = filteredRecords.reduce((acc, survey) => {
                if (!acc) {
                    // First survey becomes the base structure
                    const baseSurvey = structuredClone(survey);
                    // Add createdAt, submission_id, and uuidResearcher to each treatment in the first survey
                    if (baseSurvey.surveyRecords[0] && baseSurvey.surveyRecords[0].value) {
                        baseSurvey.surveyRecords[0].value = baseSurvey.surveyRecords[0].value.map(treatment => ({
                            ...treatment,
                            createdAt: survey.createdAt,
                            submission_id: survey.id,
                            uuidResearcher: survey.uuidResearcher
                        }));
                    }
                    return baseSurvey;
                }
                
                // Merge surveyRecords from subsequent surveys
                survey.surveyRecords.forEach((surveyRecord) => {
                    if (surveyRecord.value && Array.isArray(surveyRecord.value)) {
                        if (acc.surveyRecords[0] && acc.surveyRecords[0].value) {
                            // Add createdAt, submission_id, and uuidResearcher to each treatment before merging
                            const treatmentsWithMetadata = surveyRecord.value.map(treatment => ({
                                ...structuredClone(treatment),
                                createdAt: survey.createdAt,
                                submission_id: survey.id,
                                uuidResearcher: survey.uuidResearcher
                            }));
                            
                            acc.surveyRecords[0].value = [
                                ...acc.surveyRecords[0].value,
                                ...treatmentsWithMetadata
                            ];
                        }
                    }
                });
                                
                return acc;
            }, null);
            console.log("listElements built", listElements);
        }

        if(dataCollectionSelected !== null && (action === "fill" || action === "update")){
            const submission = action === "update" && idSubmission ? props.patientsSubmissions.data[uuidPatient][dataCollectionSelected.uuid].submissions.filter(sub => sub.id === idSubmission)[0] : null
            if(savedDataCollection){ 
                // return(
                //     <Alert severity={showSnackbar.severity}>
                //         <Translate id="hospital.patient.new-record" />
                //     </Alert>
                // )
            }
            else{
                const units = getUnitsResearcher(props.profile.info.uuid, researchers);
                const unitSurvey = dataCollectionSelected.unit ? units.find((unit) => unit.uuid === dataCollectionSelected.unit.uuid) : null;
                const surveyDepartment = unitSurvey ? units.find((unit) => unit.uuid === dataCollectionSelected.unit.uuid).department : null;

                // For prescriptions, use merged listElements instead of single submission
                const initData = isPrescriptionsInpatientSection ? listElements : submission;
                console.log("initData", JSON.stringify(initData));

                return(
                    <FillDataCollection initData = {initData} key={`${dataCollectionSelected.uuid}-${filteredRecords.length}`} dataCollection={dataCollectionSelected} 
                        sectionSelected = {sectionSelected} uuidPatient={uuidPatient} researcher={props.profile.info} idSubmission={idSubmission}
                        country={props.investigations.currentInvestigation.country} numberButtonsSubmit={2}
                        hideCollectionName={true}
                        hideButtonsSubmit={isPrescriptionsInpatientSection}
                        uuidInvestigation={props.investigations.currentInvestigation.uuid} department={surveyDepartment}
                        callBackDataCollection={(values) => saveRecord(values)}/>
                )
            }
        }
        else if(idSubmission !== null && action === "show"){
            const belongsToRequest = idSubmission && types.TYPE_FILL_SURVEY.includes(typeSurveySelected);
            const forceEdit =  dataCollectionSelected.type === types.TYPE_EDITABLE_SURVEY
            
            console.log("dataCollectionSelected of another example show 1", dataCollectionSelected);
            console.log("filteredRecords of another example show 1", filteredRecords.filter((record) => record.type !== "stay"));   //This
            console.log("surveys", props.investigations.currentInvestigation.surveys);

            /*This is rendered when I click on viewing a specific submission */
            return (
                <>  
                    {/* {
                        belongsToRequest &&
                        <RequestInfoWithFetch idSubmission={idSubmission} uuidInvestigation={props.investigations.currentInvestigation.uuid} />
                    } */}
                    <ShowPatientRecords permissions={props.investigations.currentInvestigation.permissions} 
                        forceEdit={forceEdit} survey={dataCollectionSelected} 
                        mode="elements" callBackEditSubmission={callBackEditSubmission} idSubmission={idSubmission} 
                        singleSubmission={single === 'true'} uuidInvestigation={props.investigations.currentInvestigation.uuid}
                        submissions={filteredRecords.filter((record) => record.type !== "stay")} 
                        surveys={props.investigations.currentInvestigation.surveys}
                        patient={patient} />
                </>)
        }
        else if ((types.TYPE_REQUEST_FUNC.includes(typeSurveySelected) &&  props.investigations.currentInvestigation.functionalities.includes(FUNCTIONALITY.REQUESTS))
            || (typeSurveySelected === types.TYPE_SHOE_SURVEY && props.investigations.currentInvestigation.functionalities.includes(FUNCTIONALITY.SHOE_SHOP))){
            const serviceType = typeSurveySelected === types.TYPE_LAB_SURVEY ? 0 : typeSurveySelected === types.TYPE_IMAGE_SURVEY ? 1 : 3;
            if(HOSPITAL_PATIENT_MAKE_TESTS === props.match.path){
                const units = getUnitsResearcher(props.profile.info.uuid, researchers);
            
                const departmentsResearcher = {};
                units.forEach((unit) => {
                    const department = unit.department;
                    departmentsResearcher[department.uuid] = department;
                })
                return <RequestForm serviceType={serviceType} uuidPatient={uuidPatient}  
                            uuidInvestigation={props.investigations.currentInvestigation.uuid} 
                            units = {units}
                            cancel = {() => cancelRequest()}
                            callBackRequestFinished={() => cancelRequest()}/>
            }
            const locale = props.activeLanguage?.code || 'en';
            
            return (
                <RequestTable serviceType={serviceType} uuidPatient={uuidPatient} 
                    requestServiceType={serviceType} showActions={true}
                    searchFor="general.patient" noSearchBox
                    showForm={showRequestType === 0} surveys={props.investigations.currentInvestigation.surveys}
                    uuidInvestigation={props.investigations.currentInvestigation.uuid} 
                    patient={patient}
                    activeLanguageCode={locale}
                    permissions={props.investigations.currentInvestigation.permissions}
                    setShowSnackbar={setShowSnackbar}
                    callBackRequestSelected={(req) => {
                        goToSubmissionUrl(req.requestsServiceInvestigation[0].patientInvestigation.uuid, req.submissionPatient.id)}
                    } />
            )
        }
        else if(filteredRecords.length === 0 && !isPrescriptionsInpatientSection){
            return <TypographyStyled>
                        <Translate id={`pages.hospital.${translations}.no-records`} />
                    </TypographyStyled>
        }

        else{
            const locale = props.activeLanguage?.code || 'en';
            
            return (
                <>
                <SubmissionsTable typeSurveySelected={typeSurveySelected}
                    surveys={currentSurveys} billingInfo={billingInfo} patient={patient}
                    category={currentSurveys[0].category} records={filteredRecords}
                    locale={locale}
                    onSelectSubmission={(index) => selectSubmission(index)} />
                </>
            )
            
        }
 
    }

    function editPersonalData(){
        console.log("Edit personal data");
        const nextUrl = HOSPITAL_PATIENT_EDIT_PERSONAL_DATA.replace(":uuidPatient", uuidPatient);
        console.log("Next url", nextUrl);
        history.push(nextUrl);
    }
    function closeModal(){
        setShowOptions(false);
        setShowModal(false);
        //setIndexSection(-1);
        setIndexDataCollection(-1);
    }
    function closeScheduleAppointmentModal(){
        setShowScheduleAppointmentModal(false);
    }
    function closeSurgicalListModal(){
        setShowSurgicalListModal(false);
    }
    async function resetSnackBar(){
        setShowSnackbar({show:false});
        if(props.patientsSubmissions.error){
            await dispatch(resetPatientsSubmissionsError())
        }
        if(props.hospital.error){
            async function resetError(){
                await dispatch({
                    type:types.HOSPITAL_RESET_ERROR
                })
            }
        }
        
    }
    function showConfirm(){
        setDischargeConfirm(true);
        setShowModal(true);
    }
    useEffect(() => {
        if(props.hospital.error){
            let message = "";
            switch(props.hospital.error){
                case 10: 
                    message = "hospital.patient.error.patient-alredy-discharged";
                    break;
                default:
                    message = "general.error";
            }

            setShowSnackbar({show:true, severity:"error", message : message});
        }
    }, [props.hospital.error])

    useEffect(() => {
        setShowOptions(false);
        setShowModal(false);
    }, [uuidSection])
    
    useEffect(() => {
        async function fetchRecordsPatient(){
            // SHER-483: opening the patient LIST loads SLIM metadata (no whole-history assembly).
            // But when we land DIRECTLY on a full view (detail/fill/update — e.g. a deep link or a
            // reload on the prescriptions page), load the FULL payload here so the treatment merge /
            // detail has its surveyRecords — and so the mount load doesn't race the needsFull effect
            // (a slim load resolving last would clobber the full one).
            // SHER-492: the detail view (action=show) now uses the SLIM list too — show_patient_records
            // fetches each submission's content on demand as you navigate, so we no longer bulk-load the
            // whole history to open one submission. Only the fill/update views (treatment merge) need full.
            const needsFull = action === "fill" || action === "update";
            if(needsFull){
                await dispatch(fetchSubmissionsPatientInvestigationAction(props.investigations.currentInvestigation.uuid, uuidPatient));
            } else {
                await dispatch(fetchSlimSubmissionsPatientAction(props.investigations.currentInvestigation.uuid, uuidPatient));
            }
        }
        async function fetchPatientsStay(){
            await dispatch(getPatientStaysAction(props.investigations.currentInvestigation.uuid, uuidPatient));
        }

        const submissionsNotOnlyAdditionalInfo = props.patientsSubmissions.data && props.patientsSubmissions.data.hasOwnProperty(uuidPatient) ? Object.values(props.patientsSubmissions.data[uuidPatient]).filter((surveySubs) => {
            return surveySubs.type !== types.TYPE_ADDITIONAL_INFO_SURVEY
        }).length !== Object.values(props.patientsSubmissions.data[uuidPatient]).length : false;
        if(props.investigations.data && (!props.patientsSubmissions.data || !submissionsNotOnlyAdditionalInfo)){
            fetchRecordsPatient();
            fetchPatientsStay()
        }
    }, [props.investigations])

    // SHER-483: the detail view (action=show) and the fill/update views (prescriptions/treatment
    // merge) need the FULL submissions (surveyRecords content), which the slim list omits. When we
    // enter one of those views and the store only holds slim rows, load the full payload once.
    useEffect(() => {
        // SHER-492: the detail view (action=show) now uses the SLIM list too — show_patient_records
        // fetches each submission's content on demand as you navigate, so we no longer bulk-load the
        // whole history to open one submission. Only the fill/update views (treatment merge) need full.
        const needsFull = action === "fill" || action === "update";
        if(!needsFull || !props.investigations.data || !props.investigations.currentInvestigation){
            return;
        }
        const patientData = props.patientsSubmissions.data && props.patientsSubmissions.data[uuidPatient];
        const isSlimOrMissing = !patientData || Object.values(patientData).some((surveySubs) =>
            (surveySubs.submissions || []).some((sub) => sub.__slim));
        if(isSlimOrMissing){
            dispatch(fetchSubmissionsPatientInvestigationAction(props.investigations.currentInvestigation.uuid, uuidPatient));
        }
    }, [action, idSubmission, props.investigations, props.patientsSubmissions.data])
    
    useEffect(() => {
        if(!props.profile.info && props.investigations.currentInvestigation){
            dispatch(fetchProfileInfoAction(props.investigations.currentInvestigation.uuid));
        }
    }, [props.investigations])
    useUpdateEffect(() => {

        if(action === "update"){
            setShowSnackbar({show:true, severity:"success", message : "hospital.patient.updated-record"});
        }
        if(action === "fill"){
            setShowSnackbar({show:true, severity:"success", message : "hospital.patient.new-record"});
        }
        // SHER-214 — we no longer call makeDischarge() here. addRecordToPatient
        // already runs endStay server-side (researcher.controller.ts:2929-2944)
        // when the survey type is TYPE_DISCHARGE_SURVEY; a second client-initiated
        // /discharge call would land on an already-discharged stay → 400 errorCode
        // 10 → "Ce patient a déjà obtenu son congé" toast popped immediately after
        // success. The server-side path is now the single source of truth; the API
        // is also idempotent within a 60s window as defence-in-depth against any
        // remaining race (manual button double-clicks etc.).
        //
        // SHER-114 — for DECEASED_WORKFLOW the backend extracts disposition + death
        // data from the discharge survey and runs the full discharge + deceased
        // workflow in one transaction. The client just needs to refresh patient
        // state to reflect the new status (stays/submissions + incremental sync
        // pulls DECEASED status into the patient list).
        if(dataCollectionSelected && dataCollectionSelected.type === types.TYPE_DISCHARGE_SURVEY){
            setShowSnackbar({show:true, severity:"success", message : "hospital.patient.discharged"});
            dispatch(getPatientStaysAction(props.investigations.currentInvestigation.uuid, uuidPatient));
            dispatch(fetchSubmissionsPatientInvestigationAction(props.investigations.currentInvestigation.uuid, uuidPatient));
            dispatch(incrementalSyncPatientsAction(props.investigations.currentInvestigation.uuid, true));
        }
    }, [props.patientsSubmissions.nUpdatedRegisters]);
    
    useEffect(() => {
        if(props.patientsSubmissions.data && departments){
            let tempSubmissions = []
            if(props.patientsSubmissions.data.hasOwnProperty(uuidPatient)){
                Object.values(props.patientsSubmissions.data[uuidPatient]).forEach((val)=> {
                    const tempSubs = val.submissions.map(sub => {
                        const tempSub = {...sub};
                        tempSub.surveyName = val.surveyName;
                        tempSub.uuidSurvey = val.uuid; 
                        tempSub.uuidResearcher = tempSub.researcher.uuid;
                        tempSub.typeSurvey = val.type; 
                        let departmentString = "";
                        if(tempSub.uuidUnit){
                            let department = null;
                            let unit = null;
                            departments.forEach((departmentSur) => {
                                departmentSur.units.forEach((unitDe) => {
                                    if(unitDe.uuid === tempSub.uuidUnit){
                                        unit = unitDe;
                                        department = departmentSur
                                    }
                                })
                            })
                            departmentString = department && unit ? department.name +": "+unit.name : "Department deleted";
                        }
                        tempSub.researcher = tempSub.researcher.name+" "+tempSub.researcher.surnames +" - " +departmentString;

                        return tempSub;
                    })
                    tempSubmissions = tempSubmissions.concat(tempSubs); 
                });
                tempSubmissions.sort((a, b) => {
                    const aDate = new Date(a.createdAt);
                    const bDate = new Date(b.createdAt);
                    if(aDate.getTime() > bDate.getTime()){
                        return -1
                    }
                    else{
                        return 1;
                    }
                });
            }
            
            setSurveyRecords(tempSubmissions);
        }
        
    }, [props.patientsSubmissions, departments])

    useEffect(() => {
        if(props.patientsSubmissions.error){
            let severity = "error";
            let message = "";
            if(action === "update"){
                message = "hospital.patient.error.general";
            }
            if(action === "fill"){
                message = "hospital.patient.error.general";
            }
            if(props.patientsSubmissions.error === 2){
                severity = "warning";
                if(action === "update"){
                    message = "hospital.patient.updated-record-offline";
                }
                if(action === "fill"){
                    message = "hospital.patient.new-record-offline";
                }
            }
            else if(props.patientsSubmissions.error === 401){
                severity = "error";
                message = "hospital.patient.error.permission";
            }
            else{
                setError(true);
            }
            setShowSnackbar({show:true, severity:severity, message : message});
            
        }
            
    }, [props.patientsSubmissions.loading, props.patientsSubmissions.error]);

    // Redirect to fill mode for prescriptions section to use standard flow
    useEffect(() => {
        if(isPrescriptionsInpatientSection && !action){
            dataCollectionSelected = currentSurveys.find(sur => sur.category === types.CATEGORY_DEPARTMENT_PRESCRIPTIONS_FW);
            const nextUrl = HOSPITAL_PATIENT_DATACOLLECTION
                .replace(":uuidDataCollection", dataCollectionSelected.uuid)
                .replace(":uuidPatient", uuidPatient)
                .replace(":action", "fill")
                .replace(":idSubmission", "");
            history.push(nextUrl);
        }
    }, [isPrescriptionsInpatientSection, action, dataCollectionSelected, uuidPatient]);

    if(error){
        return(
            <BoxBckgr color="text.primary" style={{padding:"1rem"}}>
                <Alert mb={4} severity="error">
                    <Translate id="investigation.share.error.description" />
                </Alert>
            </BoxBckgr>
        )
    }
    else if(loadingDeletePatient || props.investigations.loading || props.patientsSubmissions.loading || props.profile.loading  || surveyRecords === null || loadingDepartments){
        return <Loader />
    }
    else if(!patient){
        if(deletedPatient){
            return(
                <BoxBckgr color="text.primary" style={{padding:"1rem"}}>
                    <Alert mb={4} severity="success">
                        <Translate id="hospital.patient.delete.success" />
                    </Alert>
                </BoxBckgr>
            )
        }
        return(
            <BoxBckgr color="text.primary" style={{padding:"1rem"}}>
                <Alert mb={4} severity="error">
                    <Translate id="hospital.patient.error.no-patient" />
                </Alert>
            </BoxBckgr>
        ) 
    }
    else{
        if(!patient.personalData.birthdate){
            //Para recibir más info si peta aqui
            postErrorSlack("patient", {}, patient.personalData, props.investigations.currentInvestigation);
        }
        const parsedBirthdate = patient.personalData && patient.personalData.birthdate ? birthdateToDate(patient.personalData.birthdate) : null;
        let years = parsedBirthdate ? yearsFromDate(parsedBirthdate) : "Not Available";
        //let stay = daysFromDate(props.dateIn);
        const currentStay = staysPatient.find((stay) => stay.dateOut === null);
        let isPatientHospitalized = Boolean(currentStay);
        const currentInvestigation = props.investigations.currentInvestigation;
        const outpatientsInfo = currentInvestigation.outpatientsInfo ?? {};
        const canScheduleAppointment = currentInvestigation.functionalities.includes(FUNCTIONALITY.OUTPATIENTS)
            && currentInvestigation.permissions.includes(PERMISSION.CREATE_APPOINTMENTS);
        return ( 
            <React.Fragment>
                <Snackbar
                    anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                    }}
                    open={showSnackbar.show}
                    autoHideDuration={2000}
                    onClose={resetSnackBar}>
                        {
                            showSnackbar.message && 
                            <Alert onClose={() => setShowSnackbar({show:false})} severity={showSnackbar.severity}>
                                <Translate id={showSnackbar.message} />
                            </Alert>
                        }
                        
                </Snackbar>
                <Modal isTransparent={showOptions} open={showModal || loading || saved } closeModal={closeModal}>
                    {
                        saved &&
                        <CheckCircleOutlineSvg style={{ color: "green",fontSize: 80 }}/>
                    }
                    { showOptions && 
                        <div >
                        {
                            renderSurveys()
                        }
                        </div>
                    }
                    {
                        dischargeConfirm && 
                        
                        <Grid container>
                             <Grid item xs={12}>
                                <Typography variant="h6" component="div" gutterBottom>
                                    <Typography variant="body2">Are you sure you want to discharge this patient?</Typography>
                                </Typography>
                                <Typography variant="body2" style={{fontWeight:'bold'}} component="div" gutterBottom>
                                {
                                    patient.personalData &&
                                    [
                                        <Translate id="investigation.create.personal_data.fields.health_id" />, ",", getPatientID(patient)
                                    ]
                                }
                                <Typography variant="body2">
                                    <Translate id="investigation.create.personal_data.fields.name" />: {patient.personalData.name}
                                </Typography>
                                <Typography variant="body2">
                                    <Translate id="investigation.create.personal_data.fields.surnames" />: {patient.personalData.surnames}    
                                </Typography>
                                <Typography variant="body2">
                                    <Translate id="investigation.create.personal_data.fields.sex" />: {patient.personalData.sex === "Male" ? <Translate id="general.male" /> : <Translate id="general.female" />}    
                                </Typography>
                                </Typography>
                                
                             </Grid>
                             <Grid item xs={12} style={{paddingTop:'1rem'}}>
                                <ButtonCancel onClick={resetModal} data-testid="cancel-modal" color="primary" spaceright={1}>
                                    <Translate id="general.cancel" />
                                </ButtonCancel>
                                &nbsp;
                                <ButtonContinue onClick={() => discharge()} data-testid="continue-modal" color="green">
                                    <Translate id="general.continue" />
                                </ButtonContinue>
                            </Grid>
                        </Grid>
                    }
                    {
                        (showMenuHospitalize && !dischargeConfirm) &&
                        <ButtonGrey onClick={()=> {
                            setDischargeConfirm(true);
                        }} data-testid="select-hospital" >Alta Hospitalaria</ButtonGrey>
                    }
                </Modal>
                <ScheduleAppointmentModal
                    open={showScheduleAppointmentModal}
                    onClose={closeScheduleAppointmentModal}
                    uuidPatient={uuidPatient}
                    uuidInvestigation={currentInvestigation.uuid}
                    outpatientsInfo={outpatientsInfo}
                    patientPhone={patient.personalData?.phone}
                />
                {/* SHER-461: surgical-list shortcut reuses the same surgery
                    RequestForm opened from patient search, pre-bound to this patient. */}
                <Modal open={showSurgicalListModal} closeModal={closeSurgicalListModal}
                    title={<Translate id="hospital.patient.toolbar.add_to_surgical_list" />}>
                    {
                        showSurgicalListModal &&
                        <RequestForm uuidInvestigation={currentInvestigation.uuid} uuidPatient={uuidPatient}
                            serviceType={ServiceType.SURGERY} cancel={closeSurgicalListModal}
                            units={[]}
                            callBackRequestFinished={closeSurgicalListModal} />
                    }
                </Modal>
                <Grid container spacing={3}>
                    <PatientToolBar permissions={props.investigations.currentInvestigation.permissions}
                        typeSurveySelected={ dataCollectionSelected ? dataCollectionSelected.type : parameters.typeTest ? parameters.typeTest : "medical" }
                        buttonSelected = { urlToSection(parameters.typeTest, dataCollectionSelected, props.investigations.currentInvestigation.permissions)}
                        editCallBack={editPersonalData}
                        deletePatientCallBack={() => deletePatient()}
                        action={parameters} disabledAddButton={isPrescriptionsInpatientSection || (dataCollectionSelected !== null || parameters === "fill")} patientID={patient.id}
                        personalData={patient.personalData} years={years}
                        typeSurveysAvailable = { typesSurvey }
                        categorySurveys = {categorySurveys}
                        unitsResearcher={props.profile.info.units}
                        medicalNotesCallBack={() => backToRoot()}
                        buttonClickedCallBack = { (buttonClicked) => goToTest(buttonClicked)}
                        addRecordCallBack={addRecord}
                        hospitalize={ isPatientHospitalized ?  showConfirm : null }
                        patientStatus={patient.status}
                        changeStatusCallBack={props.investigations.currentInvestigation.functionalities.includes(FUNCTIONALITY.DECEASED_WORKFLOW) ? () => setShowStatusChangeModal(true) : undefined}
                        showScheduleAppointment={canScheduleAppointment}
                        scheduleAppointmentCallBack={() => setShowScheduleAppointmentModal(true)}
                        addToSurgicalListCallBack={() => setShowSurgicalListModal(true)}
                    />
                    <StatusChangeModal
                        open={showStatusChangeModal}
                        currentStatus={patient.status ?? PatientStatus.ACTIVE}
                        patientName={`${patient.personalData.name} ${patient.personalData.surnames}`}
                        onClose={() => setShowStatusChangeModal(false)}
                        onConfirm={handleStatusChange}
                    />
                        
                    <Grid item xs={12}>
                        {
                            renderCore()
                        }
                    </Grid>
                </Grid>
            </React.Fragment>
        )
    }
    
}

const mapStateToProps = (state) =>{
    return {
        investigations : state.investigations,
        patientsSubmissions:state.patientsSubmissions,
        patients:state.patients,
        profile:state.profile,
        hospital:state.hospital
    }
}
export default withLocalize(connect(mapStateToProps, null)(Patient))